import HomeActionTypes from "./home.types";
// Set the reducers initial state.
const INITIAL_STATE = {
  initialSynced: false,
  syncingHome: false,
  message: null,
  bannerList: null,
  employeeData: null,

  thingList: null,
  syncingThing: false,
  thingMessage: null,

  favoriteList: null,
  syncingFavorite: false,
  favoriteMessage: null,

  showRegisterOverlayFlag: true,
  showSigninOverlayFlag: true,
  showAccountOverlayFlag: true,
  showForgotPasswordOverlayFlag: true,
  showResetPasswordOverlayFlag: true,
  homeSlideId: null,
};

// Define scenarios for reducers.
const homeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HomeActionTypes.HOME_SYNC_START:
      return {
        ...state,
        syncingHome: true,
      };
    case HomeActionTypes.HOME_SYNC_FINISH:
      return {
        ...state,
        initialSynced: action.payload.initialSynced,
        syncingHome: action.payload.syncingHome,
        bannerList: action.payload.bannerList,
        message: action.payload.message,
      };
    case HomeActionTypes.THING_SYNC_START:
      return {
        ...state,
        syncingThing: true,
      };
    case HomeActionTypes.THING_SYNC_FINISH:
      return {
        ...state,
        thingList: action.payload.thingList,
        thingMessage: action.payload.message,
        syncingThing: false,
      };
    case HomeActionTypes.RESET_THINGS:
      return {
        ...state,
        thingList: null,
      };
    case HomeActionTypes.FAVORITE_SYNC_START:
      return {
        ...state,
        syncingFavorite: true,
      };
    case HomeActionTypes.FAVORITE_SYNC_FINISH:
      return {
        ...state,
        favoriteList: action.payload.favoriteList,
        favoriteMessage: action.payload.message,
        syncingFavorite: false,
      };
    case HomeActionTypes.RESET_FAVORITES:
      return {
        ...state,
        favoriteList: null,
      };
    case HomeActionTypes.UPDATE_HOME_SLIDE_ID:
      return {
        ...state,
        homeSlideId: action.payload,
      };
    case HomeActionTypes.UPDATE_BANNER_FAVORITE:
      const bannerIndex =
        state.bannerList?.findIndex(
          (x) => x.projectId === action.payload.projectId
        ) ?? -1;
      const thingIndex =
        state.thingList?.findIndex(
          (x) => x.projectId === action.payload.projectId
        ) ?? -1;
      const favoriteIndex =
        state.favoriteList?.findIndex(
          (x) => x.projectId === action.payload.projectId
        ) ?? -1;
      return {
        ...state,
        bannerList:
          bannerIndex !== -1
            ? [
                ...state.bannerList.slice(0, bannerIndex),
                action.payload,
                ...state.bannerList.slice(bannerIndex + 1),
              ]
            : state.bannerList,
        thingList:
          thingIndex !== -1
            ? [
                ...state.thingList.slice(0, thingIndex),
                action.payload,
                ...state.thingList.slice(thingIndex + 1),
              ]
            : state.thingList,
        favoriteList:
          favoriteIndex !== -1
            ? [
                ...state.favoriteList.slice(0, favoriteIndex),
                ...state.favoriteList.slice(favoriteIndex + 1),
              ]
            : state.favoriteList,
      };
    case HomeActionTypes.UPDATE_BANNER_SHARE:
      const bannerIndex1 =
        state.bannerList?.findIndex(
          (x) => x.projectId === action.payload.projectId
        ) ?? -1;
      const thingIndex1 =
        state.thingList?.findIndex(
          (x) => x.projectId === action.payload.projectId
        ) ?? -1;
      const favoriteIndex1 =
        state.favoriteList?.findIndex(
          (x) => x.projectId === action.payload.projectId
        ) ?? -1;
      return {
        ...state,
        bannerList:
          bannerIndex1 !== -1
            ? [
                ...state.bannerList.slice(0, bannerIndex1),
                {
                  ...state.bannerList[bannerIndex1],
                  totalShareCount:
                    (state.bannerList[bannerIndex1].totalShareCount ?? 0) + 1,
                },
                ...state.bannerList.slice(bannerIndex1 + 1),
              ]
            : state.bannerList,
        thingList:
          thingIndex1 !== -1
            ? [
                ...state.thingList.slice(0, thingIndex1),
                {
                  ...state.thingList[thingIndex1],
                  totalShareCount:
                    (state.thingList[thingIndex1].totalShareCount ?? 0) + 1,
                },
                ...state.thingList.slice(thingIndex1 + 1),
              ]
            : state.thingList,
        favoriteList:
          favoriteIndex1 !== -1
            ? [
                ...state.favoriteList.slice(0, favoriteIndex1),
                {
                  ...state.favoriteList[favoriteIndex1],
                  totalShareCount:
                    (state.favoriteList[favoriteIndex1].totalShareCount ??
                      0) + 1,
                },
                ...state.favoriteList.slice(favoriteIndex1 + 1),
              ]
            : state.favoriteList,
      };


      case HomeActionTypes.UPDATE_BANNER_COMMENT:
        const bannerCommentIndex =
          state.bannerList?.findIndex(
            (x) => x.projectId === action.payload.projectId
          ) ?? -1;
        const thingCommentIndex =
          state.thingList?.findIndex(
            (x) => x.projectId === action.payload.projectId
          ) ?? -1;
        const favoriteCommentIndex =
          state.favoriteList?.findIndex(
            (x) => x.projectId === action.payload.projectId
          ) ?? -1;
        return {
          ...state,
          bannerList:
          bannerCommentIndex !== -1
              ? [
                  ...state.bannerList.slice(0, bannerCommentIndex),
                  action.payload,
                  ...state.bannerList.slice(bannerCommentIndex + 1),
                ]
              : state.bannerList,
          thingList:
          thingCommentIndex !== -1
              ? [
                  ...state.thingList.slice(0, thingCommentIndex),
                  action.payload,
                  ...state.thingList.slice(thingCommentIndex + 1),
                ]
              : state.thingList,
          favoriteList:
          favoriteCommentIndex !== -1
              ? [
                  ...state.favoriteList.slice(0, favoriteCommentIndex),
                  ...state.favoriteList.slice(favoriteCommentIndex + 1),
                ]
              : state.favoriteList,
        };


    case HomeActionTypes.SET_EMPLOYEE_DATA:
      return {
        ...state,
        employeeData: action.payload.employeeData,
      };
    case HomeActionTypes.UPDATE_SHOW_REGISTER_OVERLAY_FLAG:
      return {
        ...state,
        showRegisterOverlayFlag: !state.showRegisterOverlayFlag,
      };
    case HomeActionTypes.UPDATE_SHOW_SIGNIN_OVERLAY_FLAG:
      return {
        ...state,
        showSigninOverlayFlag: !state.showSigninOverlayFlag,
      };
    case HomeActionTypes.UPDATE_SHOW_ACCOUNT_OVERLAY_FLAG:
      return {
        ...state,
        showAccountOverlayFlag: !state.showAccountOverlayFlag,
      };
    case HomeActionTypes.UPDATE_SHOW_RESET_PASSWORD_OVERLAY_FLAG:
      return {
        ...state,
        showResetPasswordOverlayFlag: !state.showResetPasswordOverlayFlag,
      };
    default:
      return state;
  }
};

export default homeReducer;
